export class cjsEffects {}

cjsEffects.hide = function (obj) {
  let d1 = obj.time,
    d2 = new Date();
  let diff = Math.abs(d2 - d1),
    sign = diff < 0 ? -1 : 1,
    milliseconds,
    s = obj.toVisible === true ? 0.05 : -0.05;
  let cjs = typeof obj.container === 'object' && obj.container !== undefined ? obj.container : obj.shape;

  diff /= sign;
  //milliseconds = diff % obj.speed;
  milliseconds = diff;

  if (obj.wait <= milliseconds && obj._moved === true) {
    if (obj.toVisible === true) cjs.visible = true;
    cjs.alpha += s;

    if (cjs.alpha <= 0 && obj.toVisible === false) {
      cjs.visible = obj.toVisible;
      cjs.alpha = 0;
      obj._moved = false;
      if (cjs.parent.cacheID !== 0) cjs.parent.updateCache();
      return true;
    }

    if (cjs.alpha >= 1 && obj.toVisible === true) {
      obj._moved = false;
      if (cjs.parent.cacheID !== 0) cjs.parent.updateCache();
      return true;
    }
    if (cjs.parent.cacheID !== 0) cjs.parent.updateCache();
    return false;
  } else if (obj.wait > milliseconds && obj._moved === true) {
    if (cjs.parent.cacheID !== 0) cjs.parent.updateCache();
    return false;
  }
  if (cjs.parent.cacheID !== 0) cjs.parent.updateCache();
  return true;
};

cjsEffects.flip = function (obj) {
  let d1 = obj.time,
    d2 = new Date();
  let diff = Math.abs(d2 - d1),
    sign = diff < 0 ? -1 : 1,
    milliseconds,
    s = obj.toVisible === true ? 0.05 : -0.05;
  diff /= sign;
  milliseconds = diff % obj.speed;

  if (obj.wait < milliseconds && obj._moved === true) {
    if (obj.toVisible === true) {
      obj.container.visible = true;
      obj.container.alpha = 1;
    }
    obj.container.scaleX += s;

    if (obj.container.scaleX <= -0.5 && obj.toVisible === false) {
      obj.container.visible = obj.toVisible;
      obj.container.scaleX = -0.5;
      obj.container.alpha = 0;
      obj._moved = false;
      if (obj.container.parent.cacheID !== 0) obj.container.parent.updateCache();
      return true;
    }

    if (obj.container.scaleX >= 1 && obj.toVisible === true) {
      obj._moved = false;
      if (obj.container.parent.cacheID !== 0) obj.container.parent.updateCache();
      return true;
    }
    if (obj.container.parent.cacheID !== 0) obj.container.parent.updateCache();
    return false;
  }
  if (obj.container.parent.cacheID !== 0) obj.container.parent.updateCache();
  return true;
};
